import React, {useEffect, useState} from "react";
import ReactDatePicker, {registerLocale} from "react-datepicker";
import ru from 'date-fns/locale/ru';
import "react-datepicker/dist/react-datepicker.css";
import styled, {useTheme} from "styled-components";
import {IFilter} from "../../interface/Basic/window";
import {getYear, range} from "../../utils/date";
import {SelectContainer} from "../../components/ui/Content";
import {Body1Pointer} from "../../components/Font";
import {FormSelect} from "../Select/FormSelect";
import {DatePicker} from "../../icon/Icon";
import {ChangeDateError} from "../../components/ui/InputSearch";

registerLocale('ru', ru)

interface IDatePickerProps {
    error: string
    initDate: Date | null
    onChange(value: Date): void
}

export const FormDatePicker = ({initDate, onChange, error}: IDatePickerProps) => {
    const [dateState, setDateState] = useState<Date | null>(null);
    const minDate = new Date()
    minDate.setFullYear(1900)

    useEffect(()=>{
        setDateState(initDate)
    },[initDate])

    const years: IFilter[] = range(1900, getYear(new Date()) + 1);
    const months: IFilter[] = [
        {id: 0, name: "Январь"},
        {id: 1, name: "Февраль"},
        {id: 2, name: "Март"},
        {id: 3, name: "Апрель"},
        {id: 4, name: "Май"},
        {id: 5, name: "Июнь"},
        {id: 6, name: "Июль"},
        {id: 7, name: "Август"},
        {id: 8, name: "Сентябрь"},
        {id: 9, name: "Октябрь"},
        {id: 10, name: "Ноябрь"},
        {id: 11, name: "Декабрь"},
    ];
    const Theme = useTheme()
    return <DatePickerContainer>
        <ReactDatePicker locale={'ru'}

                         renderCustomHeader={({
                                                  date,
                                                  changeYear,
                                                  changeMonth,
                                                  decreaseMonth,
                                                  increaseMonth,
                                              }) => {

                             const nextYear = new Date(date.valueOf())
                             nextYear.setMonth(nextYear.getMonth() + 1)


                             const prevMonthButtonDisabled = minDate > date
                             const nextMonthButtonDisabled = new Date() < nextYear

                             return <SelectContainer>
                                 <Body1Pointer
                                     color={prevMonthButtonDisabled ? Theme.color.secondary : Theme.color.indicator}
                                     onClick={decreaseMonth}
                                     style={prevMonthButtonDisabled ? {pointerEvents: 'none'} : {}}>
                                     {"❮"}
                                 </Body1Pointer>
                                 <FormSelect
                                     items={months}
                                     selectedItem={months.find(i => i.id === date.getMonth())}
                                     onSelect={(value) => changeMonth(value.id)}/>
                                 <FormSelect
                                     items={years}
                                     selectedItem={years.find(i => i.name === date.getFullYear().toString())}
                                     onSelect={(value) => {
                                         return changeYear(+value.name)
                                     }}/>
                                 <Body1Pointer
                                     color={nextMonthButtonDisabled ? Theme.color.secondary : Theme.color.indicator}
                                     onClick={increaseMonth}
                                     style={nextMonthButtonDisabled ? {pointerEvents: 'none'} : {}}>
                                     {"❯"}
                                 </Body1Pointer>
                             </SelectContainer>
                         }}
                         disabledKeyboardNavigation
                         dateFormat="dd.MM.yyyy"
                         selected={dateState}
                         closeOnScroll={true}
                         fixedHeight
                         minDate={minDate}
                         maxDate={new Date()}
                         onChange={(date) => {
                             if (date) {
                                 setDateState(date)
                                 onChange(date)
                             }
                         }}
        />
        <ChangeDateError error={error}>
            {error}
        </ChangeDateError>
        <DatePickerIconContainer>
            <DatePicker/>
        </DatePickerIconContainer>
    </DatePickerContainer>
};

export const DatePickerContainer = styled.label`
  display: flex;
  position: relative;
  cursor: pointer;
  input {
    height: 40px;
    margin: 0;
    background-color:  ${({theme}) => theme.color.primaryBackground};
    cursor: pointer;
  }
`

const DatePickerIconContainer = styled.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-35%);
`